/**
 * Created by ren on 16/06/2017.
 */
export const OPEN = "dt:device_status:open";
export const CLOSED = "dt:device_status:closed";
export const SUSPENDED = "dt:device_status:suspended";